export default __webpack_public_path__ + "static/rocket-de-ffc6c764e527affb311a08b4d6966d21.svg";